import React, { useEffect, useState } from "react";
import { EVENT_DATE } from "./constants";

const EventCountdownTimer = ({ spread }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // Set the target date for the conference (you can modify this date)
  const targetDate = new Date(EVENT_DATE).getTime();

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  if(timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0) {
    return null;
  }

  return (
    <div className="flex space-x-3 md:space-x-4 items-center w-full md:w-auto justify-around md:justify-center ">
      {[
        { value: timeLeft.days, label: "Days" },
        { value: timeLeft.hours, label: "Hours" },
        { value: timeLeft.minutes, label: "Minutes" },
        { value: timeLeft.seconds, label: "Seconds" },
      ].map(({ value, label }, index, arr) => (
        <React.Fragment key={label}>
          <div
            key={label}
            className={`flex  items-center ${
              spread ? "flex-row gap-1" : "flex-col"
            }`}
          >
            <div className="text-xl font-semibold leading-none lg:min-w-[30px]">
              {value.toString().padStart(2, "0")}
            </div>
            <div className="text-[10px] md:text-xs text-[#CBF07F] mt-1">
              {label}
            </div>
          </div>
          {index < arr.length - 1 && (
            <div className="h-4 w-[1px] bg-white/20 block" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default EventCountdownTimer;
